var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsUnlockIcon = function SvgDsUnlockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.948 11.889a.667.667 0 0 1-.667-.667v-.889a.667.667 0 0 1 1.334 0v.89a.667.667 0 0 1-.667.666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.244 2.703C6.701 2.264 7.332 2 8.095 2c.698 0 1.339.21 1.851.703.266.255.434.503.543.812.114.322.178.746.178 1.374v1.704H3.504c-.737 0-1.334.596-1.334 1.333V14c0 .736.597 1.333 1.334 1.333h9.037c.736 0 1.333-.597 1.333-1.333V7.926c0-.737-.597-1.333-1.333-1.333H12V4.889c0-.706-.07-1.299-.255-1.819a3.35 3.35 0 0 0-.876-1.329C10.067.97 9.074.667 8.095.667c-1.086 0-2.054.382-2.774 1.075a.667.667 0 1 0 .923.96m6.297 5.223H3.504V14h9.037z",
    clipRule: "evenodd"
  })));
};
export default SvgDsUnlockIcon;